/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as authLoginImport } from './routes/(auth)/login'
import { Route as appLayoutImport } from './routes/(app)/_layout'
import { Route as appLayoutIndexImport } from './routes/(app)/_layout/index'
import { Route as appLayoutTransactionsImport } from './routes/(app)/_layout/transactions'
import { Route as appLayoutCampaignImport } from './routes/(app)/_layout/campaign'

// Create Virtual Routes

const appImport = createFileRoute('/(app)')()

// Create/Update Routes

const appRoute = appImport.update({
  id: '/(app)',
  getParentRoute: () => rootRoute,
} as any)

const authLoginRoute = authLoginImport.update({
  id: '/(auth)/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const appLayoutRoute = appLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => appRoute,
} as any)

const appLayoutIndexRoute = appLayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appLayoutRoute,
} as any)

const appLayoutTransactionsRoute = appLayoutTransactionsImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => appLayoutRoute,
} as any)

const appLayoutCampaignRoute = appLayoutCampaignImport.update({
  id: '/campaign',
  path: '/campaign',
  getParentRoute: () => appLayoutRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(app)': {
      id: '/(app)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof appImport
      parentRoute: typeof rootRoute
    }
    '/(app)/_layout': {
      id: '/(app)/_layout'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof appLayoutImport
      parentRoute: typeof appRoute
    }
    '/(auth)/login': {
      id: '/(auth)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof authLoginImport
      parentRoute: typeof rootRoute
    }
    '/(app)/_layout/campaign': {
      id: '/(app)/_layout/campaign'
      path: '/campaign'
      fullPath: '/campaign'
      preLoaderRoute: typeof appLayoutCampaignImport
      parentRoute: typeof appLayoutImport
    }
    '/(app)/_layout/transactions': {
      id: '/(app)/_layout/transactions'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof appLayoutTransactionsImport
      parentRoute: typeof appLayoutImport
    }
    '/(app)/_layout/': {
      id: '/(app)/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof appLayoutIndexImport
      parentRoute: typeof appLayoutImport
    }
  }
}

// Create and export the route tree

interface appLayoutRouteChildren {
  appLayoutCampaignRoute: typeof appLayoutCampaignRoute
  appLayoutTransactionsRoute: typeof appLayoutTransactionsRoute
  appLayoutIndexRoute: typeof appLayoutIndexRoute
}

const appLayoutRouteChildren: appLayoutRouteChildren = {
  appLayoutCampaignRoute: appLayoutCampaignRoute,
  appLayoutTransactionsRoute: appLayoutTransactionsRoute,
  appLayoutIndexRoute: appLayoutIndexRoute,
}

const appLayoutRouteWithChildren = appLayoutRoute._addFileChildren(
  appLayoutRouteChildren,
)

interface appRouteChildren {
  appLayoutRoute: typeof appLayoutRouteWithChildren
}

const appRouteChildren: appRouteChildren = {
  appLayoutRoute: appLayoutRouteWithChildren,
}

const appRouteWithChildren = appRoute._addFileChildren(appRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof appLayoutIndexRoute
  '/login': typeof authLoginRoute
  '/campaign': typeof appLayoutCampaignRoute
  '/transactions': typeof appLayoutTransactionsRoute
}

export interface FileRoutesByTo {
  '/login': typeof authLoginRoute
  '/campaign': typeof appLayoutCampaignRoute
  '/transactions': typeof appLayoutTransactionsRoute
  '/': typeof appLayoutIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/(app)': typeof appRouteWithChildren
  '/(app)/_layout': typeof appLayoutRouteWithChildren
  '/(auth)/login': typeof authLoginRoute
  '/(app)/_layout/campaign': typeof appLayoutCampaignRoute
  '/(app)/_layout/transactions': typeof appLayoutTransactionsRoute
  '/(app)/_layout/': typeof appLayoutIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/login' | '/campaign' | '/transactions'
  fileRoutesByTo: FileRoutesByTo
  to: '/login' | '/campaign' | '/transactions' | '/'
  id:
    | '__root__'
    | '/(app)'
    | '/(app)/_layout'
    | '/(auth)/login'
    | '/(app)/_layout/campaign'
    | '/(app)/_layout/transactions'
    | '/(app)/_layout/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  appRoute: typeof appRouteWithChildren
  authLoginRoute: typeof authLoginRoute
}

const rootRouteChildren: RootRouteChildren = {
  appRoute: appRouteWithChildren,
  authLoginRoute: authLoginRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/(app)",
        "/(auth)/login"
      ]
    },
    "/(app)": {
      "filePath": "(app)",
      "children": [
        "/(app)/_layout"
      ]
    },
    "/(app)/_layout": {
      "filePath": "(app)/_layout.tsx",
      "parent": "/(app)",
      "children": [
        "/(app)/_layout/campaign",
        "/(app)/_layout/transactions",
        "/(app)/_layout/"
      ]
    },
    "/(auth)/login": {
      "filePath": "(auth)/login.tsx"
    },
    "/(app)/_layout/campaign": {
      "filePath": "(app)/_layout/campaign.tsx",
      "parent": "/(app)/_layout"
    },
    "/(app)/_layout/transactions": {
      "filePath": "(app)/_layout/transactions.tsx",
      "parent": "/(app)/_layout"
    },
    "/(app)/_layout/": {
      "filePath": "(app)/_layout/index.tsx",
      "parent": "/(app)/_layout"
    }
  }
}
ROUTE_MANIFEST_END */
